<template>
  <!-- <div :style="'width: ' + width + 'px; height: ' + height + 'px; background-color: rgb(91, 161, 230);'"></div> -->
  <div>
    <div
      v-if="title != null && title != ''"
      style="
        height: 50px;
        display: flex;
        align-items: center;
        color: white;
        background-color: rgb(91, 161, 230);
      "
    >
      <div :style="'width: ' + width / 6 + 'px'">
        <div
          style="width: 100%; height: 50px; display: flex; align-items: center"
          @click="fanhui()"
        >
          <img
            style="float: left; margin-left: 20px; width: 10px; height: 16px"
            src="../../public/img/fhimg.png"
          />
        </div>
      </div>
      <div style="width: 100%">{{ title }}</div>
      <div :style="'width: ' + width / 6 + 'px'"></div>
    </div>
    <div style="margin: 10px" v-if="sfkqhf">
      <el-button round size="small" :type="primary1" @click="spjk()"
        >视频监控</el-button
      >
      <el-button round size="small" :type="primary2" @click="lxhf()"
        >录像回放</el-button
      >
    </div>
    <div id="video-container"></div>
  </div>
</template>
<script>
// import { getcapacity } from '../utils/getxx'
// import EZUIKit from "ezuikit-js"

export default {
  data() {
    return {
      height: window.innerHeight, //  - 18
      width: window.innerWidth,
      title: null,
      isFullscreen: false,
      primary1: "primary",
      primary2: "",
      sfkqhf: false,
    };
  },
  created() {
    this.title = this.$route.query.title;
    this.sfkqhf = true;

    // if (this.$route.query.hf == "true") {
    //   this.sfkqhf = true;
    // } else {
    //   if (
    //     this.$route.query.deviceName.length >= 9 &&
    //     "FZ5857372|FZ5857380|FZ5857375|FZ5857420|FZ5857384|FZ5857394|FZ5857357|FZ5857374|FZ5857404|FZ5857371|FZ5857383|FZ5857364|FR4029548".includes(
    //       this.$route.query.deviceName
    //     )
    //   ) {
    //   }
    // }
  },
  components: {},
  async mounted() {
    var t = this;
    window.addEventListener("resize", function () {
      t.height = window.innerHeight;
      t.width = window.innerWidth;
    });
    // const targetElement = document.getElementById("video-container-expend");
    // const observer = new MutationObserver((mutations) => {
    //   mutations.forEach((mutation) => {
    //     if (mutation.attributeName === "class") {
    //       console.log("Class changed:", targetElement.className);
    //       // 触发Vue数据更新或方法
    //       this.handleClassChange();
    //     }
    //   });
    // });
    // observer.observe(targetElement, {
    //   attributes: true,
    //   attributeFilter: ["class"],
    // });
    // this.$once("hook:beforeDestroy", () => observer.disconnect()); // 组件销毁时停止监听
    await this.getVideoData();
  },
  destroyed() {
    if (this.ezopen) {
      this.ezopen.destroy();
    }
  },
  methods: {
    async getVideoData() {
      try {
        if (typeof window.EZUIKit === "undefined") {
          await this.loadScript("//oss.eelink.com/js/ezuikit.js");
        }
        this.getjiazai({
          accessToken: this.$route.query.accessToken,
          deviceName: this.$route.query.deviceName,
          url: this.$route.query.url,
        });
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error("初始化监控出错：", err);
      }
    },
    loadScript(src) {
      return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) {
          resolve();
          return;
        }
        const s = document.createElement("script");
        s.src = src;
        s.async = true;
        s.onload = () => resolve();
        s.onerror = () => reject(new Error(`Failed to load ${src}`));
        document.head.appendChild(s);
      });
    },
    getjiazai(item) {
      // 使用 window.EZUIKit 来初始化播放器
      setTimeout(() => {
        this.ezopen = new window.EZUIKit.EZUIKitPlayer({
          id: "video-container",
          width: this.width,
          height: (this.width * 9) / 16,
          template: "pcLive", //pcLive //ec9519f383a24f1d9c485c1e328c6793 //mobileLive
          url: item.url,
          accessToken: item.accessToken,
          scaleMode: 0, // 默认 0 完全填充窗口，会有拉伸 1: 等比适配 2: 等比完全填充窗口, 超出隐藏 @sine 8.2.0
          handleError: (err) => {
            if (
              err.type === "handleRunTimeInfoError" &&
              err.data.nErrorCode === 5
            ) {
              // 加密设备密码错误
            }
          },
        });
        window.ezopen = this.ezopen;
      }, 100);
    },
    getVideoDataHf() {
      setTimeout(() => {
        var jkhf =
          this.$route.query.url.slice(0, this.$route.query.url.length - 4) +
          "rec";
        this.ezopen = new window.EZUIKit.EZUIKitPlayer({
          id: "video-container",
          width: this.width,
          height: (this.width * 9) / 16,
          template: "pcRec", //pcLive //ec9519f383a24f1d9c485c1e328c6793 //mobileLive
          url: jkhf,
          accessToken: this.$route.query.accessToken,
          scaleMode: 0, // 默认 0 完全填充窗口，会有拉伸 1: 等比适配 2: 等比完全填充窗口, 超出隐藏 @sine 8.2.0
          handleError: (err) => {
            if (
              err.type === "handleRunTimeInfoError" &&
              err.data.nErrorCode === 5
            ) {
              // 加密设备密码错误
            }
          },
        });
        window.ezopen = this.ezopen;
      }, 100);
    },
    onFh() {
      console.log(111);
    },
    showNativeToast() {
      if (window.AndroidBridge) {
        AndroidBridge.showToast("Hello!");
      }
    },
    fanhui() {
      if (window.AndroidBridge) {
        AndroidBridge.fanhui();
      }
    },
    spjk() {
      this.primary1 = "primary";
      this.primary2 = "";
      this.ezopen.destroy();
      this.getVideoData();
    },
    lxhf() {
      this.primary1 = "";
      this.primary2 = "primary";
      this.ezopen.destroy();
      this.getVideoDataHf();
    },
    async fetchDeviceInfo() {
      if (window.AndroidBridge) {
        const deviceInfo = await AndroidBridge.getDeviceInfo();
        this.deviceModel = deviceInfo;
      }
    },
  },
};
</script>
